export default __webpack_public_path__ + "static/media/img6.efb1507c.png";